import { NotificationType } from 'src/graphql/types/notifications'
import IconChecklist from 'src/icons/IconChecklist'
import IconClipboardList from 'src/icons/IconClipboardList'
import IconDocumentSearch from 'src/icons/IconDocumentSearch'
import IconEmail from 'src/icons/IconEmail'
import IconGraduationCap from 'src/icons/IconGraduationCap'
import IconMessage from 'src/icons/IconMessage'
import IconNotes from 'src/icons/IconNotes'

export const NOTIFICATION_TYPE_CONFIG = {
  [NotificationType.SMS]: {
    icon: (
      <IconMessage className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
    ),
    label: 'Text Message',
  },
  [NotificationType.EMAIL]: {
    icon: (
      <IconEmail className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
    ),
    label: 'Email',
  },
  [NotificationType.TASK]: {
    icon: (
      <IconChecklist className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
    ),
    label: 'Tasks',
  },
  [NotificationType.NOTE]: {
    icon: (
      <IconNotes className="h-4 w-4 fill-doubleNickel-gray-500" />
    ),
    label: 'Notes',
  },
  [NotificationType.ORDER_UPDATE]: {
    icon: (
      <IconClipboardList className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
    ),
    label: 'Order Update',
  },
  [NotificationType.VOE_RESPONSE]: {
    icon: (
      <IconDocumentSearch className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
    ),
    label: 'Employment Verification',
  },
  [NotificationType.TRAINING]: {
    icon: (
      <IconGraduationCap className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
    ),
    label: 'Training',
  },
} as const

export const getNotificationConfig = (type: string) => {
  return (
    NOTIFICATION_TYPE_CONFIG[type as NotificationType] || {
      icon: (
        <IconNotes className="h-4 w-4 fill-doubleNickel-gray-500" />
      ),
      label: 'Notification',
    }
  )
}
